import React, { Component } from "react";
import Button from "@material-ui/core/Button";
// import NonOpImage from "../../assets/non-op.png";
import JourneyToWellness_1 from "../../../src/assets/pdf/JourneyToWellness(1).pdf";

import GetAppIcon from "@material-ui/icons/GetApp";

import "./JointNoi1.css";
import "./LearnAbout.css";

class LearnAboutPartRecp extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  _downloadPdf = () => {
    var link = document.createElement("a");
    link.innerHTML = "Download ";
    link.download = "JourneyToWellness_1.pdf";
    link.href = JourneyToWellness_1;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  render() {
    return (
      <div id="RCPE-Welcome-main-container">
        <div id="all-content-wrapper">
          <div id="LearnAbout-box-1">
            <div id="LearnAbout-inner-box-1">
              {/* Dic 1 */}
              <div id="RCPNOI-container-1">
                <h2 id="RCPNOI-heading">
                  {" "}
                  {`About Partial Joint Replacement Surgery`}{" "}
                </h2>

                <div id="RCPNOI-form-box-1">
                  <form id="RCPNOI-form">
                    <div className="RCPNOI-heading-1-wrapper">
                      <div
                        className="RCPNOI-heading-1-button-2-wrapper"
                        onClick={this._downloadPdf}
                      >
                        <GetAppIcon style={{ color: "#B4EC51" }} />
                      </div>
                      <div className="RCPNOI-heading-1"
                        onClick={this._downloadPdf} style={{ cursor: 'pointer' }} >
                        Learn About Your Journey to Wellness
                      </div>

                    </div>
                    <ul className="LearnAbout-unstyled RCPNOIcentered">
                      {[
                        "What is a partial joint replacement?",
                        "Is a joint placement right for me?",
                        "Preparing for surgery",
                        "Recovery after surgery",
                        "Life with a joint replacement",
                      ].map((text,i) => (
                        <li key={i}>
                          <label htmlFor={text} className="RCPNOI-form-field">
                            -{text}
                          </label>
                        </li>
                      ))}
                    </ul>
                  </form>

                  {/* <img alt="App-Image" src={NonOpImage} id="JN1-Image" /> */}
                </div>
              </div>
            </div>
          </div>

          <div id="RCPE-Welcome-box-2">
            <div id="RCPE-Welcome-footer-div1">
              <Button
                id="RCPE-Welcome-btn-1"
                variant="contained"
                onClick={this.props.handleBackClick}
              >
                {" "}
                Back{" "}
              </Button>
              <Button
                id="LearnAbout-btn-2"
                variant="contained"
                onClick={this._downloadPdf}
              >
                {" "}
                Download Education{" "}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LearnAboutPartRecp;
